import { joinBy } from '@pbk/utils';
import * as contentDisposition from 'content-disposition';
import isString from 'lodash/isString';
import mime from 'mime-types';
import { FILE_EXTENSION_REGEX } from '../regex';
export const composeFileNameFromHeaders = ({ contentDisposition: contentDispositionHeader, contentType: contentTypeHeader, }) => {
    const maybeContentDispositionString = isString(contentDispositionHeader)
        ? contentDispositionHeader
        : undefined;
    const maybeContentTypeString = isString(contentTypeHeader)
        ? contentTypeHeader
        : undefined;
    if (!maybeContentDispositionString || !maybeContentTypeString)
        return null;
    try {
        const { parameters } = contentDisposition.parse(maybeContentDispositionString);
        const maybeFileName = parameters.filename;
        const hasFileNameExtension = maybeFileName
            ? FILE_EXTENSION_REGEX.test(maybeFileName)
            : false;
        if (hasFileNameExtension) {
            return maybeFileName;
        }
        const contentTypeExtension = mime.extension(maybeContentTypeString);
        if (!maybeFileName || !contentTypeExtension)
            return null;
        return joinBy([maybeFileName, contentTypeExtension], '.');
    }
    catch (e) {
        // `contentDisposition.parse` throws an exception if the input is invalid
        return null;
    }
};
